/* Cart-only controls. Native submission preserves properties, notes and checkout. */
(function () {
  'use strict';
  var form = document.getElementById('bl-cart-form');
  if (!form || form.dataset.blBound) return;
  form.dataset.blBound = 'true';
  var status = form.querySelector('[data-bl-cart-status]');
  var updateButton = form.querySelector('[data-bl-update-submit]');
  var busy = false;
  function syncPricingLines() {
    var rows = Array.from(form.querySelectorAll('[data-bl-cart-line]'));
    var totals = Object.create(null);
    rows.forEach(function (row) {
      var ref = row.getAttribute('data-product-customizer-pricing-ref');
      var ratio = Number(row.getAttribute('data-product-customizer-pricing-qty'));
      var input = row.querySelector('[data-bl-quantity-input]');
      if (row.dataset.blFee === 'true' || !ref || !input) return;
      if (!Number.isSafeInteger(ratio) || ratio <= 0) throw new Error('Your options could not be updated. Please reload the cart and try again.');
      totals[ref] = (totals[ref] || 0) + Number(input.value) * ratio;
    });
    rows.forEach(function (row) {
      if (row.dataset.blFee !== 'true') return;
      var ref = row.getAttribute('data-product-customizer-pricing-ref');
      var input = row.querySelector('[data-bl-quantity-input]');
      // Never silently delete an unrelated pricing line.
      if (input && Object.prototype.hasOwnProperty.call(totals, ref)) input.value = String(totals[ref]);
    });
  }
  function submitUpdate(input, quantity) {
    if (busy) return;
    if (!Number.isSafeInteger(quantity) || quantity < 0) {
      input.value = input.dataset.originalQuantity;
      status.textContent = 'Please enter a whole-number quantity.';
      return;
    }
    input.value = String(quantity);
    form.requestSubmit(updateButton);
  }
  form.addEventListener('click', function (event) {
    var step = event.target.closest('[data-bl-quantity-step]');
    var remove = event.target.closest('[data-bl-remove]');
    if (!step && !remove) return;
    event.preventDefault(); event.stopImmediatePropagation();
    var input = (step || remove).closest('[data-bl-cart-line]').querySelector('[data-bl-quantity-input]');
    submitUpdate(input, remove ? 0 : Math.max(1, Number(input.value) + Number(step.dataset.blQuantityStep)));
  }, true);
  form.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches('[data-bl-quantity-input]') || input.type === 'hidden') return;
    event.stopImmediatePropagation();
    var quantity = Number(input.value);
    if (input.value.trim() === '' || quantity < 1) {
      input.value = input.dataset.originalQuantity;
      status.textContent = 'Use Remove to remove an item, or enter a quantity of one or more.';
      return;
    }
    submitUpdate(input, quantity);
  }, true);
  form.addEventListener('submit', function (event) {
    if (busy) { event.preventDefault(); return; }
    try { syncPricingLines(); }
    catch (error) { event.preventDefault(); status.textContent = error.message; return; }
    busy = true; form.setAttribute('aria-busy', 'true');
    status.textContent = event.submitter && event.submitter.name === 'checkout' ? 'Opening secure checkout…' : 'Updating your cart…';
    // Do not disable the submitter: its name is needed for native checkout.
  }, true);
  window.addEventListener('pageshow', function () {
    busy = false; form.removeAttribute('aria-busy'); status.textContent = '';
  });
})();
